export default function LoginCtrl(
) {
  // Redirect to web2 login when somebody tries to login
  window.location.href = `${window.__env.baseNewAppUrl}/login`;
}
